interface HeaderNavProps {
  activeSection: string;
  navigateTo: (sectionKey: string) => void;
}

const INTERNAL = [
  { key: 'brand', label: '品牌介紹' },
  { key: 'directions', label: '出版方向' },
  { key: 'books', label: '最新發行' },
  { key: 'info', label: '常見問題' },
  { key: 'blog', label: '編輯選書' },
];

export default function HeaderNav({ activeSection, navigateTo }: HeaderNavProps) {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[200] px-3 sm:px-5 lg:px-10 py-4 sm:py-5 flex items-center gap-3 justify-between pointer-events-none"
      style={{
        pointerEvents: 'none',
        backgroundColor: 'rgba(7,18,48,0.35)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      {/* 品牌 Logo */}
      <button
        onClick={() => navigateTo('hero')}
        className="flex min-w-0 shrink-0 items-center gap-3 cursor-pointer pointer-events-auto"
        style={{ pointerEvents: 'auto' }}
      >
        <span
          className="font-michroma text-white text-sm tracking-[0.2em]"
          style={{ fontSize: 'clamp(13px, 1.4vw, 16px)' }}
        >
          STRATDOT
        </span>
        <span className="hidden sm:inline-block w-px h-4 bg-white/25" />
        <span className="hidden sm:inline-block font-manrope text-white/80 text-xs tracking-[0.2em]">
          策點文化
        </span>
      </button>

      {/* 導覽 */}
      <nav
        aria-label="首頁導覽"
        className="hidden lg:flex min-w-0 flex-1 items-center justify-start xl:justify-end gap-1 overflow-x-auto overscroll-x-contain no-scrollbar pointer-events-auto"
        style={{ pointerEvents: 'auto' }}
      >
        {INTERNAL.map((item) => (
          <button
            key={item.key}
            onClick={() => navigateTo(item.key)}
            className="shrink-0 px-3 py-1.5 rounded-md font-manrope text-xs uppercase tracking-[0.15em] whitespace-nowrap cursor-pointer transition-colors duration-200"
            style={{
              color: activeSection === item.key ? '#fff' : 'rgba(255,255,255,0.6)',
              backgroundColor: activeSection === item.key ? 'rgba(255,255,255,0.1)' : 'transparent',
            }}
          >
            {item.label}
          </button>
        ))}
        <button
          onClick={() => navigateTo('channels')}
          className="shrink-0 px-3 py-1.5 rounded-md font-manrope text-xs uppercase tracking-[0.15em] whitespace-nowrap cursor-pointer transition-colors duration-200"
          style={{
            color: activeSection === 'channels' ? '#fff' : 'rgba(255,255,255,0.6)',
            backgroundColor: activeSection === 'channels' ? 'rgba(255,255,255,0.1)' : 'transparent',
          }}
        >
          合作通路
        </button>
        <a
          href="https://catalog.sonbook.net/"
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 px-3 py-1.5 rounded-md font-manrope text-xs uppercase tracking-[0.15em] whitespace-nowrap cursor-pointer transition-colors duration-200 inline-flex items-center gap-1"
          style={{ color: 'rgba(255,255,255,0.6)' }}
        >
          書籍資料庫
          <i className="ri-external-link-line text-[10px] opacity-60"></i>
        </a>
        <a
          href="https://sonbook.net/"
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 px-3 py-1.5 rounded-md font-manrope text-xs uppercase tracking-[0.15em] whitespace-nowrap cursor-pointer transition-colors duration-200 inline-flex items-center gap-1"
          style={{ color: 'rgba(255,255,255,0.6)' }}
        >
          崧博出版
          <i className="ri-external-link-line text-[10px] opacity-60"></i>
        </a>
      </nav>

      {/* 手機版精簡入口 */}
      <div
        aria-label="快速連結"
        className="lg:hidden min-w-0 flex flex-1 items-center justify-end gap-1 overflow-x-auto overscroll-x-contain no-scrollbar pointer-events-auto"
        style={{ pointerEvents: 'auto' }}
      >
        <button
          onClick={() => navigateTo('channels')}
          className="shrink-0 px-2.5 py-1.5 rounded-md font-manrope text-[11px] whitespace-nowrap cursor-pointer"
          style={{ color: 'rgba(255,255,255,0.7)' }}
        >
          通路
        </button>
        <a
          href="https://catalog.sonbook.net/"
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 px-2.5 py-1.5 rounded-md font-manrope text-[11px] whitespace-nowrap cursor-pointer"
          style={{ color: 'rgba(255,255,255,0.7)' }}
        >
          資料庫
        </a>
        <a
          href="https://sonbook.net/"
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 px-2.5 py-1.5 rounded-md font-manrope text-[11px] whitespace-nowrap cursor-pointer"
          style={{ color: 'rgba(255,255,255,0.7)' }}
        >
          崧博
        </a>
      </div>
    </div>
  );
}
